<span class="holder">
  <i class="icon ic-companies-16" [hidden]="holder.$type !== 'CorporateHolderModel'"></i>
  <i class="icon ic-my-account-16" [hidden]="holder.$type !== 'IndividualHolderModel'"></i>
  <span>{{ holder.name }}</span>
</span>
